import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'irembogov-service-validation-rule-wrapper',
  templateUrl: './service-validation-rule-wrapper.component.html',
  styleUrls: ['./service-validation-rule-wrapper.component.scss'],
})
export class ServiceValidationRuleWrapperComponent
  extends FieldWrapper
  implements OnInit, OnDestroy
{
  collapsed?: boolean = undefined;
  subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.initCollapsedContent();

    this.subscriptions.add(
      this.field?.options?.fieldChanges
        ?.pipe(
          filter((e: FormlyValueChangeEvent) => {
            return (
              (e.type === 'expressionChanges' &&
                e.field === this.field &&
                e['property'] === 'props.collapsible') ||
              e['property'] === 'props.collapsed'
            );
          })
        )
        .subscribe(() => {
          this.initCollapsedContent();
        })
    );
  }

  initCollapsedContent(): void {
    if (this.field?.props?.['collapsible']) {
      this.collapsed = this.field?.props?.['collapsed'] ?? false;
    } else {
      this.collapsed = undefined;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
